import { createNotificationReadService } from '../application/createNotificationReadService';
import { supabaseNotificationReadPort } from '../infrastructure/supabaseNotificationPort';

export const notificationReadService = createNotificationReadService(supabaseNotificationReadPort);
